import React from 'react';

import { CheckboxIcon } from '../../../../../../../components/Icons/CheckboxIcon';
import { EmptyCheckboxIcon } from '../../../../../../../components/Icons/EmptyCheckboxIcon';
import { FishCatchesIcon } from '../../../../../../../components/Icons/FishCatchesIcon';
import NextImage from 'next/image';
import { Text } from '../../../../../../../components/Text/Text';

export type OnSpeciesClick = (params: { speciesId: string; isSelected: boolean }) => () => void;

interface IProps {
  id: string;
  name: string;
  totalCount: number;
  isSelected: boolean;
  onClick: OnSpeciesClick;
  imageSrc?: string;
}

export const SingleSpeciesRow = ({
  name,
  totalCount,
  imageSrc,
  onClick,
  isSelected,
  id,
}: IProps) => (
  <button
    type="button"
    className="flex h-[72px] items-center"
    onClick={onClick({ speciesId: id, isSelected })}
  >
    <div className="w-col-2 sm:w-col-4 flex items-center justify-center p-3">
      {imageSrc ? (
        <NextImage
          className="size-full object-cover"
          src={imageSrc}
          alt={name}
          width={92}
          height={60}
        />
      ) : (
        <FishCatchesIcon size={55} />
      )}
    </div>
    <div className="w-col-4 sm:w-col-7 md:w-col-8">
      <Text variant="sm" className="mb-0 text-left font-semibold text-trench">
        {name} ({totalCount})
      </Text>
    </div>
    <div className="w-col-1 sm:w-col-2">
      {isSelected ? <CheckboxIcon className="inline-block" /> : <EmptyCheckboxIcon />}
    </div>
  </button>
);
